import { takeLatest, call, put, delay } from "redux-saga/effects"
import { getKbMakingJobDetails } from "../services/bifrostServices"
import {
	GET_KB_MAKING_DETAILS_REQUEST,
	GET_KB_MAKING_DETAILS_REQUEST_SUCCESS,
	GET_KB_MAKING_DETAILS_REQUEST_FAILED,
	GET_KB_MAKING_DETAILS_REQUEST_FAILED_CLEAR,
} from "../types"
import { CLIENT_SIDE_MESSAGES as Messages, clearLocalStorage } from "../utils"
import { clearMultibase } from "../actions/multiAiBase"
import { logoutUser } from "../actions/userActions"
import { hideAlert, showAlertAction } from "../actions/alertActions"
import axiosClient from "axios"

function* getKbMakingDetailsSaga(action) {
	try {
		const result = yield call(getKbMakingJobDetails, action.payload)

		if (result.status === 200 && result.data.success === true) {
			yield put({
				type: GET_KB_MAKING_DETAILS_REQUEST_SUCCESS,
				payload: result.data.bifrost_job,
			})
		} else {
			yield put({
				type: GET_KB_MAKING_DETAILS_REQUEST_FAILED,
				payload: result,
			})
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put({
					type: GET_KB_MAKING_DETAILS_REQUEST_FAILED,
					payload: Messages.SERVER_ERROR,
				})

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))
				yield delay(3000) //After 3sec message disappear
				yield put({ type: GET_KB_MAKING_DETAILS_REQUEST_FAILED_CLEAR })
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export default function* bifrostKbMakingDetailsSaga() {
	yield takeLatest(GET_KB_MAKING_DETAILS_REQUEST, getKbMakingDetailsSaga)
}
